/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./createTagPopover.vue?vue&type=template&id=50fa6cac&"
import script from "./createTagPopover.vue?vue&type=script&lang=js&"
export * from "./createTagPopover.vue?vue&type=script&lang=js&"
import style0 from "./createTagPopover.vue?vue&type=style&index=0&id=50fa6cac&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports